<template>
    <div>
        <template v-if="options.type==='content'">
            <div class="w-11/12 h-auto relative block" @click="$eventbus.$emit('search:modal:_hide')">
                <router-link :to="{
                    name: 'catalogue',
                    params: {
                        slug: options.data.slug,
                    }
                }">
                    {{ options.data.phrase }}

                    <div class="text-dodger_blue text-sm">{{ options.data.slug.replace('-', ' ') }}</div>
                </router-link>
            </div>
        </template>

        <template v-if="options.type==='images'">
            <div class="w-11/12 h-auto relative block" @click="$eventbus.$emit('search:modal:_hide')">
<!--                <router-link :to="{-->
<!--                    name: 'catalogue',-->
<!--                    params: {-->
<!--                        slug: options.data.slug,-->
<!--                    }-->
<!--                }">-->

<!--                    <div class="w-full aspect-w-16 aspect-h-11 rounded-lg shadow-2xl overflow-hidden">-->
<!--                        <template v-if="options.data.type==='images'">-->
<!--                            <img :src=" $i18n.locale + '/images/pages/' + options.data.slug + '/' + options.data.src " class="w-full object-cover"/>-->
<!--                        </template>-->
<!--                        <template v-if="options.data.type==='richmedia'">-->
<!--                            <img :src=" $i18n.locale + '/richmedia/' + options.data.slug + '/' + options.data.src " class="w-full object-cover"/>-->
<!--                        </template>-->
<!--                    </div>-->

<!--                    <span v-html="contentForData(options.data).title"></span>-->
<!--                </router-link>-->


                <div class="text-center" @click="richmediaShowDiaporama([
                        {
                            ...$t('pages').getBySlug(options.data.slug)[options.data.type][options.data.key] ,
                            ...{
                                src: options.data.type==='richmedia'
                                    ? $i18n.locale + '/richmedia/' + options.data.slug + '/' + $t('pages').getBySlug(options.data.slug)[options.data.type][options.data.key].src
                                    :  $i18n.locale + '/images/pages/' + options.data.slug + '/' + $t('pages').getBySlug(options.data.slug)[options.data.type][options.data.key].src,
                            },
                        }
                ])">
                    <div class="w-full aspect-w-16 aspect-h-11 rounded-lg shadow-2xl overflow-hidden ">
                        <template v-if="options.data.type==='images'">
                            <img :src=" $i18n.locale + '/images/pages/' + options.data.slug + '/' + options.data.src " class="w-full object-cover cursor-pointer"/>
                        </template>
                        <template v-if="options.data.type==='richmedia'">
                            <img :src=" $i18n.locale + '/richmedia/' + options.data.slug + '/' + options.data.src " class="w-full object-cover cursor-pointer"/>
                        </template>
                    </div>

                    <span v-html="contentForData(options.data).title"></span>
                </div>

            </div>
        </template>

        <template v-if="options.type==='richmedia'">
            <div class="w-11/12 h-auto relative block text-center" @click="$eventbus.$emit('search:modal:_hide')">
                <div @click="richmediaShowDiaporama([
                        {
                            ...$t('pages').getBySlug(options.data.slug)[options.data.type][options.data.key] ,
                            ...{
                                src:  $i18n.locale + '/richmedia/' + options.data.slug + '/' + $t('pages').getBySlug(options.data.slug)[options.data.type][options.data.key].src,
                            },
                            
                        }
                ])">
                    <div class="aspect-w-64 aspect-h-36 rounded-lg shadow-2xl cursor-pointer">
                            <!-- <img :src=" $i18n.locale + '/images/pages/' + options.data.slug + '/' + options.data.thumb " class="w-full object-cover"/> -->

                           
                        <img :src="options.data.thumb" class="w-full object-cover"/> 
                    </div>
                    <span v-html="contentForData(options.data).title"></span>


                </div>

            </div>
        </template>

    </div>
</template>

<script>
import SearchMixins from "../mixins/SearchMixins";
import RichmediaMixin from "../mixins/RichmediaMixin";

export default {
    name: "ModalSearchBox",
    mixins: [SearchMixins, RichmediaMixin],
    props: {
        options: null,
    },
    mounted() {
        console.log('options', this.options);
    }
}
</script>

<style scoped>
</style>
